import React from 'react';
import { Block, DividerBlockData } from '../../../config';
import './divider-block.scss';

interface DividerBlockProps {
  block: Block;
  onChange: (data: DividerBlockData) => void;
  onDelete: () => void;
  isEditing: boolean;
}

const DividerBlock: React.FC<DividerBlockProps> = ({ block }) => {
  const data = block.data as DividerBlockData;

  return (
    <div className="divider-block">
      <hr className={`divider-line style-${data.style}`} />
    </div>
  );
};

export default DividerBlock;
